import { getSetting } from "@/redux/rtk/features/setting/settingSlice";
import buildTableData from "@/UI/buildTableData";
import tablePDFGenerator from "@/utils/tablePDFGenerator";
import "jspdf-autotable";
import { useEffect } from "react";
import { BsPrinter } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";

export default function PrintPDF({ title, columns = [], list = [], icon = true }) {
  const companyInfo = useSelector((state) => state?.setting?.data) || null;
  const dispatch = useDispatch();

  const tableHead = (columns || [])
    .filter((c) => !c.csvOff)
    .map((c) => ({ header: c.title ?? c.dataIndex ?? "", dataKey: c.title ?? c.dataIndex ?? "" }));

  const tableBody = buildTableData(columns, list);

  const settings = {
    jsPDF: { orientation: "landscape" },
    tableFontSize: 10,
    infoTopFontSize: 10,
    bottomRightFontSize: 10,
    bottomLeftFontSize: 8,
    footerFontSize: 10,
  };

  useEffect(() => {
    if (!companyInfo) dispatch(getSetting());
  }, [dispatch, companyInfo]);

  return (
    <div className="flex gap-2 hover:text-black">
      <button
        className="flex items-center gap-1 px-2 py-1 hover:text-black"
        onClick={() =>
          tablePDFGenerator("print", { title, tableBody, companyInfo, tableHead, settings })
        }
      >
        {icon && <BsPrinter size={12} />}
        <span>Print PDF</span>
      </button>
    </div>
  );
}
